import React from 'react';
import * as styles from './PostViewBanner.module.scss';

interface PostViewBannerProps {
  banner: string;
  setInnerBannerRef: React.Ref<HTMLDivElement>;
}

const PostViewBanner = ({
  banner,
  setInnerBannerRef: innerBannerRef,
}: PostViewBannerProps) => (
  <div className={styles.container}>
    <div
      className={styles.banner}
      style={{ backgroundImage: `url(${banner})` }}
      ref={innerBannerRef}
    />
  </div>
);

export default PostViewBanner;
